import { watch } from 'vue'
import { mapActions } from 'vuex'

export default {
  props: {
    refDoc: {
      type: String,
      required: true,
    },
    refId: {
      type: String,
      required: true,
    },
    refCode: {
      type: String,
      required: true,
    },
    showLog: {
      type: Boolean,
      default: false,
    },
    showAttachFile: {
      type: Boolean,
      default: false,
    },
    logTopics: {
      type: Array,
      default: () => ([]),
    },
    isSubmitted: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      modalConfirmDelete: {
        show: false,
        loading: false,
      },
      confirmDeleteType: null, // enum: log, file
      confirmDeleteLogId: null,
      confirmDeleteFileId: null,
    }
  },

  watch: {
    isSubmitted() {
      if (this.isSubmitted === false) {
        this.fetchAcitivityList()
      }
    },
  },

  destroyed() {
    this.resetVuexState()
  },

  methods: {
    ...mapActions('document', {
      resetState: 'resetState',
    }),
    resetVuexState() {
      this.resetState()
    },
    handleCloseConfirmDelete() {
      this.modalConfirmDelete.show = false
    },
    handleCancleConfirmDelete() {
      this.modalConfirmDelete.show = false
    },
    handleSumitConfirmDelete() {
      if (this.confirmDeleteType === 'log') {
        this.onDeleteLog(this.confirmDeleteLogId)
      } else if (this.confirmDeleteType === 'file') {
        this.onDeleteFile(this.confirmDeleteFileId)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/docRef.js